import { IWidgetMeta } from './types';

// WidgetMeta strage
let widgetMetas: IWidgetMeta[] = [];

// Available widget meta types
// must be below 30 characters
export enum WidgetMetaTypes {
  matchCenterBannerSticky = 'match_center_banner_sticky',
  matchCenterBannerBgImage = 'match_center_banner_bg_image',
  matchCenterBannerLinks = 'match_center_banner_links',
  matchCenterEventId = 'match_center_event_id',
  bannerCodeDesktop = 'banner_code_desktop',
  bannerCodeMobile = 'banner_code_mobile',
  outrightOddsCompetitorIconType = 'ou_competitor_icon_type',
  leagueCenterTournamentStageId = 'lc_tournament_stage_id',
  leagueCenterTournamentStageName = 'lc_tournament_stage_name',
  hideImage = 'hide_image',
  complianceText = 'compliance_text',
  ctaButtonText = 'cta_button_text',
  ctaButtonLink = 'cta_button_link',
  showStandings = 'show_standings',
  hideEventsWithoutOdds = 'hide_events_without_odds'
}

// Get current meta data by metaType
export const getMeta = (metaType: WidgetMetaTypes): string|null => {
  const currentWidgetMeta = widgetMetas.find(widgetMeta => widgetMeta.type === metaType)
  return currentWidgetMeta ? currentWidgetMeta.value : null;
}

// Load all widget meta to WidgetMeta storage
export const setUpWidgetMetas = (newWidgetMetas: IWidgetMeta[]): void => {
  widgetMetas = newWidgetMetas;
}

// Used in Match Centering
export const getEventIdFromMetas = (widgetMetas: IWidgetMeta[]): number|null => {
  let eventId: number|null = null;
  widgetMetas.forEach((widgetMeta: IWidgetMeta) => {
    if (widgetMeta.value && (widgetMeta.type === WidgetMetaTypes.matchCenterEventId)) {
      eventId = parseInt(widgetMeta.value);
    }
  })

  return eventId;
}
